import { appendVueRoute } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';

/**
 * The page behind the „Benachrichtigungen ändern“ link of a notification mail
 * (TM-9527). Rendered without keycloak: the signed `token` path parameter is the
 * only authorization, and the view forwards it in the
 * `x-notification-settings-token` header.
 */
const routes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'notificationSettingsPublic'>(
      'notificationSettingsPublic',
      '/benachrichtigungen/:token',
    ),
    component: () => import('@src/views/NotificationSettingsPublic.vue'),
    meta: {
      layout: 'none',
      title: 'Benachrichtigungen',
      hideTitle: true,
      requiresAuth: false,
      requiresOnboarding: false,
    },
  },
];

export default routes;
